import styled, { keyframes } from 'styled-components';

const firstPaw = keyframes`
 0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
`;

export const LoadingIndicatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  color: ${({ theme }) => theme.core.colors.greyscale.dark};

  width: 100%;

  span {
    font-family: ${({ theme }) => theme.core.fontFamily.semiBold};
    font-size: ${({ theme }) => theme.core.fontSizes.l}px;
  }

  svg {
    color: ${({ theme }) => theme.core.colors.greyscale.dark};

    .print-1,
    .print-2,
    .print-3,
    .print-4 {
      animation-direction: alternate;

      animation-iteration-count: infinite;
      animation: ${firstPaw} 1s infinite;
    }

    .print-2 {
      animation-delay: 0.2s;
    }
    .print-3 {
      animation-delay: 0.4s;
    }
    .print-4 {
      animation-delay: 0.6s;
    }
  }
`;
